import { Expose, Transform } from 'class-transformer';

import { Model } from './model';

export class ReviewsReport extends Model {
  @Expose() teacherName: string;
  @Expose() teacherId: string;
  @Expose() studentName: string;
  @Expose() studentId: string;
  @Expose() reviewReasons: string;
  @Expose() reviewId: string;
  @Expose() rate: number;
  @Expose() connectionQualityRate: number;
  @Expose() comment: string;
  @Expose() adminApprove: boolean;
  @Expose() mobileNumber: string;
  @Expose()
  @Transform(({ value }) => (value ? new Date(value) : null))
  date: Date | null;
}
